<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="#">BrevisVelox</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-if="isLoggedIn">
          <b-nav-item class="mr-2"
            ><b-link to="/" exact exact-active-class="text-warning"
              ><font-awesome-icon icon="home"/></b-link
          ></b-nav-item>
          <b-nav-item
            ><b-link to="/clients/" exact exact-active-class="text-warning"
              ><font-awesome-icon
                icon="theater-masks"
                class="mr-2"
              />Clients</b-link
            ></b-nav-item
          >
          <b-nav-item
            ><b-link to="/projects/" exact exact-active-class="text-warning"
              ><font-awesome-icon
                icon="clipboard-list"
                class="mr-2"
              />Projects</b-link
            ></b-nav-item
          >
          <b-nav-item
            ><b-link to="/packages/" exact exact-active-class="text-warning"
              ><font-awesome-icon
                icon="box-open"
                class="mr-2"
              />Packages</b-link
            ></b-nav-item
          >
          <b-nav-item>
            API TOKEN:
            <b-button
              size="sm"
              class="ml-2"
              v-clipboard:copy="token"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <font-awesome-icon icon="copy" />
            </b-button>
          </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->

        <b-navbar-nav class="ml-auto" v-if="isLoggedIn">
          <b-nav-text>{{ user }}</b-nav-text>
          <b-nav-item
            ><b-link to="/newuser/" exact-active-class="text-warning" exact
              ><font-awesome-icon icon="user-plus" /> Add Admin</b-link
            ></b-nav-item
          >
          <b-nav-item
            ><a @click="logout"><font-awesome-icon icon="sign-out-alt"/></a
          ></b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["isLoggedIn"],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      // arrow functions can make the code very succinct!
      user: (state) => state.login.user,
      token: (state) => state.login.token,
    }),
  },
  methods: {
    logout: function() {
      this.$store.dispatch("login/logout").then(() => {
        this.$router.push("/login");
      });
    },
    onCopy: function(e) {
      alert("You just copied the following text to the clipboard: " + e.text);
    },
    onError: function(e) {
      alert("Failed to copy the text to the clipboard");
      console.log(e);
    },
  },
};
</script>
<style scoped>
.nav-link a {
  color: #fff;
}
</style>
